export default "__VITE_ASSET__BZgHtaIt__"